import api from "../../utils/API";

const getAllExperiencesMissionForSelect = () => {
  return api.get(`/gestion/experiencesmissionforselect/list`);
};

export {getAllExperiencesMissionForSelect};
